import GlobalStyle from './GlobalStyle';
import Homepage from './pages/Homepage';

function App() {
  return (
    <>
      <GlobalStyle />
      <Homepage />
    </>
  );
}

export default App;
